import { type CSSProperties, type FC } from "react";
import { Tag } from "widgets";

import type { SavedItemTagFragment } from "@/modules/saved-items/graphql/saved-items.gql.ts";

interface ProjectTagProps {
  projectTag: SavedItemTagFragment;
  style?: CSSProperties;
}

const defaultTagColor = "var(--disabled-border)";

const ProjectTag: FC<ProjectTagProps> = (props) => {
  return (
    <Tag
      key={props.projectTag.id}
      intentColor={props.projectTag.color ?? defaultTagColor}
      label={props.projectTag.name}
      style={props.style}
    />
  );
};

export { ProjectTag };
